import { render } from "./LogoutView.vue?vue&type=template&id=10495602&ts=true"
import script from "./LogoutView.vue?vue&type=script&lang=ts"
export * from "./LogoutView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__